/**
 * The date a changelog entry counts as — its `updated` date when an entry was
 * extended after release, else its `date`. Used for sorting and display, so an
 * updated entry rises to the top like a new one.
 */
export function changelogDate(meta: { date?: unknown; updated?: unknown } | undefined): string {
  return String(meta?.updated ?? meta?.date ?? '')
}
